export var isDefaultLang = function isDefaultLang(lang) {
  return !!(lang && lang.iso === (process.env.DEFAULT_LANG || 'en'));
};